import { render, staticRenderFns } from "./complianceSetup.vue?vue&type=template&id=30da8cc7"
import script from "./complianceSetup.vue?vue&type=script&lang=js"
export * from "./complianceSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports